let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("go6sV")).then(() => parcelRequire('h9YUg'));